// action
import {
    DELETE_PREGNANCY_HIGHLIGHTS,
    DELETE_PREGNANCY_HIGHLIGHTS_FAIL,
    DELETE_PREGNANCY_HIGHLIGHTS_SUCCESS,
    DELETE_PREGNANCY_HIGHLIGHTS_RESET
} from '../action/deletePregnancyHighlightsAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_PREGNANCY_HIGHLIGHTS:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_PREGNANCY_HIGHLIGHTS_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_PREGNANCY_HIGHLIGHTS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_PREGNANCY_HIGHLIGHTS_RESET:
            return initialState
        default:
            return state
    }
}